import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useThemeableSystemData } from './Provider';
var ViewportSizeContext = createContext({
    viewportSize: 'expanded',
    spacingMode: 'normal'
});
export var useViewportSize = function () { return useContext(ViewportSizeContext); };
export var ViewportSizeProvider = function (_a) {
    var children = _a.children, setMaxViewSize = _a.setMaxViewSize, setSpacingMode = _a.setSpacingMode;
    var browserViewport = useThemeableSystemData().browserViewport;
    var getSizeClass = function () {
        if (browserViewport !== undefined) {
            if (browserViewport === 'expanded' && setMaxViewSize === 'compact')
                return 'compact';
            if (browserViewport === 'medium' && setMaxViewSize === 'compact')
                return 'compact';
            if (browserViewport === 'expanded' && setMaxViewSize === 'medium')
                return 'medium';
            return browserViewport;
        }
        return 'compact';
    };
    var getEffectiveSpacingMode = function () {
        return setSpacingMode || 'normal';
    };
    return (_jsx(ViewportSizeContext.Provider, { value: {
            viewportSize: getSizeClass(),
            spacingMode: getEffectiveSpacingMode()
        }, children: children }));
};
